import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const usePersistQueryParam = (paramKey: string) => {
    const location = useLocation()
    const navigate = useNavigate()
    const storedValueRef = useRef<string | null>(null)
    const hasInitialValueRef = useRef(false)

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const currentValue = params.get(paramKey)
        if (currentValue) {
            storedValueRef.current = currentValue
            hasInitialValueRef.current = true
            return
        }

        if (!hasInitialValueRef.current || !storedValueRef.current) {
            return
        }

        params.set(paramKey, storedValueRef.current)
        const nextSearch = params.toString()

        navigate(
            {
                pathname: location.pathname,
                search: nextSearch ? `?${nextSearch}` : '',
                hash: location.hash,
            },
            { replace: true },
        )
    }, [location, navigate, paramKey])
}
